const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'registration',
        'slider',
    ],

    methods: {

        focusTabGranted(registerSecret){
            const storage = this.getStorage()
            const customerContact = (((storage.user || {}).data || {}).userTableAssociates || {}).customerContact || {}
            const {
                customerContactID,
                customerID,
                registrationCompletedAt,
            } = customerContact
            const registrationCompleted = registrationCompletedAt || this.model.stepComplete.editFinish

            const registryKeys = Object.keys(this.registry)
            const viewIndex = utils.indexOf(registryKeys, registerSecret)
            const editViewIndex = utils.indexOf(registryKeys, 'editBase')
            const finishViewIndex = utils.indexOf(registryKeys, 'finish')
            let result = true
            let tabContentContainer, propertiesForm, submitDone

            // no premature emailActivation text display
            if(!customerContactID && registerSecret === 'emailActivation' && !this.model.stepComplete.register) {
                result = false

                tabContentContainer = this.getTabComponent('register', false)
                if(tabContentContainer){
                    tabContentContainer.find('templates_registration_form', form => {
                        propertiesForm = form
                    })
                }

                if(propertiesForm){
                    propertiesForm.submit()
                        .fail(status => {
                            if(status === 'validationFailed' && this.model.activeRegisterSecret !== 'register'){
                                this.focusTab('register', true)
                            }
                        })

                } else {
                    result = true
                    this.stepComplete()
                }

            }
            // profile management requires a user to be logged in
            else if (!customerContactID && viewIndex >= editViewIndex){
                result = false
                this.focusTab('login', true)
            }
            // registration complete users get to see finish step only
            else if(customerContactID && registrationCompleted && viewIndex < finishViewIndex) {
                result = false
                this.focusTab('finish', true)
            }
            // registration incomplete logged-in users have to manage their personal profile
            else if(customerContactID && !registrationCompleted && viewIndex < editViewIndex) {
                result = false
                this.focusTab('editBase', true)
            }
            // registration incomplete logged-in users have to manage their profile step by step
            else if(customerContactID && !registrationCompleted && viewIndex > editViewIndex) {
                result = false
                let invalidMandatoryStepFound = false

                for(let mandatoryViewIndex = editViewIndex; mandatoryViewIndex < Math.min(finishViewIndex, viewIndex); mandatoryViewIndex++) {
                    const mandatoryViewRegisterSecret = registryKeys[mandatoryViewIndex]

                    if(!this.model.stepComplete[mandatoryViewRegisterSecret]){

                        tabContentContainer = this.getTabComponent(mandatoryViewRegisterSecret, false)
                        if(tabContentContainer){
                            tabContentContainer.find('templates_registration_form', form => {
                                propertiesForm = form
                            })
                        }

                        if(propertiesForm){
                            invalidMandatoryStepFound = true
                            submitDone = propertiesForm.submit()
                        } else {
                            this.focusTab(mandatoryViewRegisterSecret, true)
                        }

                        break
                    }
                }

                if(!invalidMandatoryStepFound){
                    result = true
                }
            }

            // refresh customer form after customerContact is ready
            if(registerSecret === 'editCustomer'){
                submitDone = submitDone || utils.promise.resolve()
                submitDone.then(() => {
                    const tabContentContainer = this.getTabComponent(registerSecret)
                    let form
                    if(tabContentContainer){
                        tabContentContainer.find('templates_registration_form', c => form = c)
                        if(form){
                            return form.refresh()
                        }
                    }
                })
            }

            return result
        },
    }
}